// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"571ff1e6","845":"93e874d6"}[chunkId] + ".chunk.js";
};